import SProjects from 'modules/main/layouts/SpecialProjects';
import styled, { css } from 'styled-components';
import { whiteTheme } from 'styles/themes/whiteTheme';
import { ContentBanner } from '../ContentBanner';
import { SectionTitle } from '../SectionTitle';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 316px;
  width: 100%;
  position: relative;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      max-width: 290px;
    }
    ${theme.media.laptop} {
      max-width: 290px;
    }
    ${theme.media.tabletS} {
      order: 0;
      max-width: 100%;
      width: 100%;
    }
  `};
`;

export const BannerArticleContainer = styled.div`
  width: 100% !important;
  height: 570px !important;
  margin-bottom: 45px;
  & a,
  & a div,
  & a p,
  & img,
  & div,
  & div p,
  & p {
    max-width: 100% !important;
    width: 100% !important;
    height: 100% !important;
    display: flex;
    justify-content: center;
  }
  & ul {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  & li {
    list-style-type: none;
  }
  ${({ theme }) => css`
    ${theme.media.desktop} {
      height: 510px !important;
    }
    ${theme.media.tabletS} {
      display: none;
    }
  `};
`;

export const BannerArticle = styled(ContentBanner)`
  display: flex;
  flex-direction: column;
  max-width: 316px !important;
  width: 100% !important;
  height: 570px !important;
  margin-bottom: 45px;
  & a,
  & a div,
  & a p,
  & img,
  & div,
  & div p,
  & p {
    max-width: 100% !important;
    width: 100% !important;
    height: 100% !important;
    display: flex;
    justify-content: center;
  }
  & ul {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  & li {
    list-style-type: none;
  }
  ${({ theme }) => css`
    ${theme.media.tabletS} {
      display: none;
    }
  `};
`;

export const SpecialProjects = styled(SProjects).attrs(() => ({
  settings: {
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [],
  },
}))`
  width: calc(100% - 90px);
  margin: 0 auto;
  margin-bottom: 20px;
  .bfKTMK,
  .dCmddb {
    left: 30px;
  }
  .ijmEQB,
  .flMYCj {
    right: 30px;
  }
  & .PrevArrow {
    left: -34px;
  }
  & .NextArrow {
    right: -34px;
  }
  .hYUqAJ {
    max-width: 210px;
    width: 100%;
    margin: 0 auto;
    ${({ theme }) => css`
      ${theme.media.desktop} {
        max-width: 200px;
      }
    `};
  }
  .dVFguz {
    max-width: 210px;
    width: 100%;
    height: 210px;
  }
  & div .fxQElo,
  & div .dRSZKV {
    left: 20px;
  }
  & div .hTdnZz,
  & div .czmXtu {
    right: 20px;
  }
  .kCteGZ {
    font-size: 27px;
  }
  ${({ theme }) => css`
    ${theme.media.tabletS} {
      display: none;
    }
  `};
`;

export const TitleArticle = styled(SectionTitle)`
  font-size: 32px;
  line-height: 40px;
  margin: 0 0 30px;
  :nth-of-type(1) {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 30px;
  }
  ${({ theme }) => css`
    ${theme.media.tabletS} {
      display: none;
    }
  `};
`;
export const TitleArticleh4 = styled.h4`
  font-size: 32px;
  line-height: 40px;
  margin: 0 0 30px;
  :nth-of-type(1) {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 30px;
  }
  display: block;
  width: 100%;
  font-family: cormorant-garamond, serif;
  font-style: normal;
  font-weight: 500;
  color: #000000;
  text-align: center;
  ${whiteTheme.media.mobileM} {
    font-size: 30px;
    margin-bottom: 20px;
  }
  ${({ theme }) => css`
    ${theme.media.tabletS} {
      display: none;
    }
  `};
`;
